<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import { projectUtils } from '@/utils/project';

export default {
 inject: ['setLoading'],   
 data() {
  return {
   errors: {}, 
   title: "Projects",
   text: "Workspace",
   data: [],
   pagination: {
    current_page: 1,
    per_page: 20,
    last_page: 1,
    total: 0,
    links: []
   },
   loadingMore: false,
   search: '',
   status: '',
   priority: '',
   start_date: '',
   end_date: '',
   projectUtils
  };
 },

 computed: {
  serialNo(){
   return (this.pagination.current_page - 1) * this.pagination.per_page;
  },
  text1(){
   return `Projects (${this.pagination.total})`;
  },  
  hasMorePages(){
   return this.pagination.current_page < this.pagination.last_page;
  },
  remainingItems(){
   return this.pagination.total - this.data.length;
  }
 },

 mounted() {
  this.dateRangePicker();
  this.projects();  
 },
 
 methods: {
  
  async projects(page = 1, append = false){
   this.errors = {}; 
   if(!append){
    this.setLoading(true);
   }
   try{
    const payload = {
     page,
     search: this.search,
     status: this.status,
     priority: this.priority,
     per_page: this.pagination.per_page
    };
    const query_string = new URLSearchParams(payload).toString();
    const response = await axios.get(`/projects?${query_string}`);
    if(append){
     this.data = [...this.data, ...response.data.data.data];
    }else{
     this.data = response.data.data.data;
    }
    this.pagination = {
     current_page: response.data.data.current_page,
     per_page: response.data.data.per_page,
     last_page: response.data.data.last_page,
     total: response.data.data.total,
     links: response.data.data.links
    };
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   } 
  },

  async loadMore(){
   if(this.loadingMore || !this.hasMorePages) return;
    this.loadingMore = true;
   try{
    await this.projects(this.pagination.current_page + 1, true);
   }finally{
    this.loadingMore = false;
   }
  },

  booking_range(start, end) {
   return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
  },

  setDateRange(start, end) {
   this.start_date = start.format("YYYY-MM-DD");
   this.end_date = end.format("YYYY-MM-DD");
  },

  dateRangePicker(){
   const start = moment().subtract(6, "days");
   const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
    );
    // Initialize filter date range as soon as picker mounts
    this.setDateRange(start, end); 
  },

  clearFilter() {
   this.status = '';
   this.search = '';
   this.priority = '';
   this.projects();
   // Optionally reset date picker UI too
   // (e.g., manually set this.$refs.dateRangeInput.value)
  }

 },

};
</script>

<style scoped>
/* ── FILTER ── */
.p-filter-select {
  height: 36px; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none; cursor: pointer;
  transition: border-color .15s; min-width: 120px;
}
.p-filter-select:focus { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,.1); }
 
.p-date-input {
  height: 36px; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none; width: 200px;
  transition: border-color .15s;
}
.p-date-input:focus { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,.1); }
 
.p-search-wrap {
  display: flex; align-items: center;
  border: 1.5px solid #e2e8f0; border-radius: 8px;
  overflow: hidden; background: #fff;
}
.p-search-wrap:focus-within { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,.1); }
.p-search-input {
  border: none; outline: none; height: 34px;
  padding: 0 10px; font-size: 12.5px; color: #1e293b;
  width: 170px; background: transparent;
}
.p-search-btn {
  width: 36px; height: 36px; background: #0f172a;
  border: none; color: #fff; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; transition: background .15s;
}
.p-search-btn:hover { background: #1e293b; }
 
.p-clear-btn {
  width: 34px; height: 34px; background: #fff0f3;
  border: 1.5px solid #fecdd3; border-radius: 8px;
  color: #f43f5e; font-size: 15px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.p-clear-btn:hover { background: #f43f5e; color: #fff; border-color: #f43f5e; }
 
/* ── PROJECT CARD ── */
.p-card {
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  overflow: hidden;
  transition: box-shadow .2s, border-color .2s, transform .2s;
  height: 100%;
}
.p-card:hover {
  box-shadow: 0 8px 24px rgba(99,102,241,.1);
  border-color: #c7d2fe;
  transform: translateY(-2px);
}
 
/* Top color bar */
.p-card-bar {
  height: 4px;
}
 
.p-card-body { padding: 16px; }
 
/* Header */
.p-card-head {
  display: flex; align-items: flex-start;
  justify-content: space-between; margin-bottom: 12px;
}
 
.p-project-name {
  font-size: 13.5px; font-weight: 700; color: #0f172a;
  text-decoration: none; transition: color .15s; display: block;
}
.p-project-name:hover { color: #6366f1; }
 
.p-code-badge {
  font-size: 10px; color: #6366f1;
  background: #eef2ff; border: 1px solid #c7d2fe;
  border-radius: 20px; padding: 1px 8px;
  display: inline-block; margin-top: 3px; font-weight: 600;
}
 
/* Priority badge */
.p-priority {
  font-size: 10px; font-weight: 700; border-radius: 20px;
  padding: 2px 9px; display: inline-block;
}
.p-priority.Low      { background: #f0fdf4; color: #16a34a; border: 1px solid #86efac; }
.p-priority.Medium   { background: #fffbeb; color: #d97706; border: 1px solid #fde68a; }
.p-priority.High     { background: #fff7ed; color: #ea580c; border: 1px solid #fed7aa; }
.p-priority.Urgent   { background: #fff0f3; color: #f43f5e; border: 1px solid #fecdd3; }
 
/* Status badge */
.p-status {
  font-size: 10px; font-weight: 600; border-radius: 20px;
  padding: 2px 9px; display: inline-block;
}
.p-status.Planning    { background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; }
.p-status.in-progress { background: #f0fdf4; color: #16a34a; border: 1px solid #86efac; }
.p-status.on-hold     { background: #fffbeb; color: #d97706; border: 1px solid #fde68a; }
.p-status.Completed   { background: #f0fdf4; color: #16a34a; border: 1px solid #86efac; }
.p-status.Cancelled   { background: #fff0f3; color: #f43f5e; border: 1px solid #fecdd3; }
 
/* Divider */
.p-divider { height: 1px; background: #f1f5f9; margin: 12px 0; }
 
/* Manager row */
.p-manager {
  display: flex; align-items: center; gap: 8px;
}
.p-manager img {
  width: 28px; height: 28px; border-radius: 50%;
  object-fit: cover; border: 2px solid #e2e8f0;
  flex-shrink: 0;
}
.p-manager-name { font-size: 12px; font-weight: 600; color: #1e293b; }
.p-manager-role { font-size: 10.5px; color: #94a3b8; }
 
/* Deadline */
.p-deadline-label { font-size: 10px; color: #94a3b8; text-transform: uppercase; letter-spacing: .4px; }
.p-deadline-val   { font-size: 12px; font-weight: 600; color: #f43f5e; }
 
/* Customer badge */
.p-customer-badge {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 11px; color: #1e293b; font-weight: 500;
  background: #f8fafc; border: 1px solid #e2e8f0;
  border-radius: 8px; padding: 3px 10px;
  text-decoration: none; transition: all .15s;
}
.p-customer-badge:hover { background: #eff6ff; border-color: #bfdbfe; color: #6366f1; }
 
/* Progress circle wrapper */
.p-progress-wrap {
  position: relative; display: inline-flex;
  align-items: center; justify-content: center;
  width: 46px; height: 46px;
}
.p-progress-pct {
  position: absolute; font-size: 9.5px; font-weight: 700; color: #1e293b;
}
 
/* Load more */
.p-load-more {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 9px 24px; border-radius: 10px;
  background: #fff; border: 1.5px solid #e2e8f0;
  font-size: 13px; font-weight: 600; color: #475569;
  cursor: pointer; transition: all .15s; text-decoration: none;
}
.p-load-more:hover { background: #eff6ff; border-color: #bfdbfe; color: #6366f1; }
.p-load-more:disabled { opacity: .6; cursor: not-allowed; }
 
/* Spin animation */
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
.animate-spin { animation: spin 1s linear infinite; }
</style>
 
<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
 
<div class="page-wrapper">
<div class="content">
 
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
      <a href="javascript:void(0);"
        data-bs-toggle="modal" data-bs-target="#project_modal"
        class="btn btn-primary d-flex align-items-center"
        @click="$refs.projectModal.add();">
        <i class="ti ti-circle-plus me-2"></i>Add Project
      </a>
    </div>
  </div>
 
  <!-- Filter Card -->
  <div class="card border-0 shadow-sm mb-4" style="border-radius:14px; overflow:hidden;">
    <div class="card-body py-3 px-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
 
      <h5 class="mb-0 fw-bold" style="font-size:14px; color:#0f172a;">
        Projects
        <span style="font-size:11px; color:#94a3b8; font-weight:500; margin-left:6px;">({{ pagination.total }})</span>
      </h5>
 
      <div class="d-flex align-items-center flex-wrap gap-2">
 
        <!-- Clear -->
        <button v-if="search !== '' || status !== '' || priority !== ''" class="p-clear-btn" @click="clearFilter()" title="Clear filters">
          <i class="ti ti-filter-x"></i>
        </button>
 
        <!-- Date Range -->
        <input type="text" class="p-date-input date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy" />
 
        <!-- Status -->
        <select class="p-filter-select" v-model="status" @change="projects">
          <option value="">Status</option>
          <option value="Planning">Planning</option>
          <option value="In Progress">In Progress</option>
          <option value="On Hold">On Hold</option>
          <option value="Completed">Completed</option>
          <option value="Cancelled">Cancelled</option>
        </select>
 
        <!-- Priority -->
        <select class="p-filter-select" v-model="priority" @change="projects">
          <option value="">Priority</option>
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
          <option value="Urgent">Urgent</option>
        </select>
 
        <!-- Search -->
        <div class="p-search-wrap">
          <input type="text" class="p-search-input" v-model="search" placeholder="Search projects..." />
          <button class="p-search-btn" type="button" @click="projects">
            <i class="ti ti-search"></i>
          </button>
        </div>
 
      </div>
    </div>
  </div>
 
  <!-- Project Grid -->
  <div class="row g-3" v-if="data?.length">
 
    <div class="col-12" v-for="(row, index) in data" :key="index">
      <div class="p-card">
 
        <!-- Top color bar — dynamic per project -->
        <div class="p-card-bar"
          :style="{ background: `linear-gradient(90deg, hsl(${(row.name.charCodeAt(0) * 37) % 360}, 60%, 55%), hsl(${(row.name.charCodeAt(0) * 37 + 40) % 360}, 60%, 65%))` }">
        </div>
 
        <div class="p-card-body">
 
          <!-- Header: name + dropdown -->
          <div class="p-card-head">
            <div>
              <router-link :to="{ name: 'project-details', params: { id: row?.id } }" class="p-project-name">
                {{ row.name }}
              </router-link>
              <span class="p-code-badge">{{ row.code }}</span>
            </div>
            <div class="dropdown" v-if="projectUtils.visibleTo(auth, row?.project_manager, clientAdmin)">
              <a href="javascript:void(0);" class="d-inline-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="ti ti-dots-vertical" style="color:#94a3b8;"></i>
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    data-bs-toggle="modal" data-bs-target="#project_modal"
                    @click="$refs.projectModal.project(row);">
                    <i class="ti ti-edit me-2"></i>Edit
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    data-bs-toggle="modal" data-bs-target="#delete_modal"
                    @click="$refs.projectModal.project(row);">
                    <i class="ti ti-trash me-1"></i>Delete
                  </a>
                </li>
              </ul>
            </div>
          </div>
 
          <!-- Status + Priority badges -->
          <div class="d-flex align-items-center gap-2 mb-3">
            <span :class="['p-status', row.status?.toLowerCase().replace(' ', '-')]">{{ row.status }}</span>
            <span :class="['p-priority', row.priority]">{{ row.priority }}</span>
          </div>
 
          <div class="p-divider"></div>
 
          <!-- Manager + Deadline -->
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="p-manager">
              <img :src="$profileImage(row?.project_manager?.image, clientAdmin)" alt="manager" />
              <div>
                <div class="p-manager-name">{{ row?.project_manager?.name }}</div>
                <div class="p-manager-role">Project Manager</div>
              </div>
            </div>
            <div class="text-end">
              <div class="p-deadline-label">Deadline</div>
              <div class="p-deadline-val">{{ row.end_date ? $formatDate(row.end_date) : 'N/A' }}</div>
            </div>
          </div>
 
          <div class="p-divider"></div>
 
          <!-- Customer + Progress -->
          <div class="d-flex align-items-center justify-content-between">
 
            <router-link :to="{ name: 'customers-details', params: { id: row?.customer?.id } }" class="p-customer-badge">
              <i class="ti ti-building" style="font-size:12px; color:#6366f1;"></i>
              {{ row?.customer?.company_name || 'N/A' }}
            </router-link>
 
            <!-- Progress Circle -->
            <div class="p-progress-wrap">
              <svg width="46" height="46" style="transform: rotate(-90deg);">
                <circle cx="23" cy="23" r="18" fill="none" stroke="#e9ecef" stroke-width="4"></circle>
                <circle
                  cx="23" cy="23" r="18" fill="none"
                  stroke="#6366f1" stroke-width="4" stroke-linecap="round"
                  :stroke-dasharray="`${projectUtils.calculateProgress(row?.task_stats?.completed, row?.task_stats?.total) * 1.131} 113.1`">
                </circle>
              </svg>
              <span class="p-progress-pct">
                {{ projectUtils.calculateProgress(row?.task_stats?.completed, row?.task_stats?.total) }}%
              </span>
            </div>
 
          </div>
 
        </div>
      </div>
    </div>
 
    <!-- Load More -->
    <div class="col-md-12" v-if="hasMorePages">
      <div class="text-center mb-2 mt-2">
        <button @click="loadMore" :disabled="loadingMore" class="p-load-more">
          <i :class="loadingMore ? 'ti ti-loader-3 animate-spin' : 'ti ti-loader-3'" style="color:#6366f1;"></i>
          {{ loadingMore ? 'Loading...' : `Load More (${remainingItems} remaining)` }}
        </button>
      </div>
    </div>
 
    <!-- All loaded -->
    <div class="col-md-12" v-else-if="data?.length">
      <div class="text-center mb-3 mt-1" style="font-size:12px; color:#94a3b8;">
        All projects loaded ({{ pagination.total }} total)
      </div>
    </div>
 
  </div>
 
  <!-- Empty State -->
  <div v-else class="text-center py-5" style="color:#94a3b8;">
    <i class="ti ti-layout-grid" style="font-size:40px; display:block; margin-bottom:10px; opacity:.3;"></i>
    No projects found.
  </div>
 
</div>
 
<app-footer></app-footer>
</div>
 
<project-modal ref="projectModal" @updated="projects"></project-modal>
</template>